<template>
  <CommonRegion />
  <CommonPowerMode />
  <CommonAdvisor />
  <CommonPdfExport />
  <CommonGrid />
  <CommonInactivity />
  <CommonHotKeys />
</template>

<script setup lang="ts">
import CommonAdvisor from './CommonAdvisor.vue'
import CommonGrid from './CommonGrid.vue'
import CommonHotKeys from './CommonHotKeys.vue'
import CommonInactivity from './CommonInactivity.vue'
import CommonPdfExport from './CommonPdfExport.vue'
import CommonPowerMode from './CommonPowerMode.vue'
import CommonRegion from './CommonRegion.vue'

defineOptions({ name: 'CommonSettings' })
</script>
